module.exports = __webpack_public_path__ + "static/media/nearest_hospitals.9c0b3c4d.png";